import React, {
  useEffect,
  useRef, useState
} from 'react';
import CashCalculator from './cashCalculator';
import countryDenominations from '@components/CounterCash/countryDenominations';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import cn from 'classnames';
import { getObjectValue } from '@utility/utills';
import CounterCash from '@components/CounterCash';
import Modal from '@components/common/Modal';
import styles from './index.module.css';
import EventEmitter from '@utility/eventSubscribers';
import uniqBy from 'lodash/uniqBy';
import Loader from '@components/common/Loader/newLoaderModal';
import { flowType } from '../../utility/userInfo';
import { urlSearchParams } from '../../utility/utills';
import PropTypes from 'prop-types';

const CashReturn = ({
  totalAmount = 0.00,
  paymentType,
  deviceInfo,
  tableData,
  userInfo,
  handleReceiptPopUpOpen = () => { },
  handleCheck = () => { },
  setDrawerVisiblityProps,
  handleHideCancelIcon,
  handleChangePaymentType,
  isCounter,
  receiptTypes
}) => {
  const isPaymentTerminal = flowType() === 'paymentTerminal';
  const isServerApp = flowType() === 'serverApp';
  const countryCode = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('auth')).countryCode, 1);
  const cashCalculatorRef = useRef(null);
  const currenySymbol = LABEL().CURRENCY_SYMBOL;
  const [groupedList, setGroupedList] = useState({});
  const [Amount, setAmount] = useState('0.00');
  const [preDefinedValue, setPreDefinedValue] = useState(true)
  const [changeAmount, setChangeAmount] = useState('0.00');
  const [isCounterCash, setIsCounterCash] = useState(false);
  const [drawerAlert, setDrawerAlert] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerVisibilty, setDrawerVisiblity] = useState(false);
  const { drawerIpAddress, drawerPort } = deviceInfo;
  const [loader, setLoader] = useState(false);
  const eventObj = { drawerIpAddress, drawerPort };
  const possibleCashOptions = [];
  const receiptButtons = [
    { key: 'phone', label: LABEL().SMS, show: receiptTypes?.sms },
    { key: 'paper', label: LABEL().PAPER, show: receiptTypes?.print },
    { key: 'email', label: LABEL().EMAIL, show: receiptTypes?.email },
    { key: 'none', label: LABEL().NONE, show: true },
  ];
  const getPossibleCashOptions = (totalAmount) => {
    const possibleRoundUps = {
      1: 1,
      2: 5,
      3: 10,
      4: 20,
      5: 50,
      6: 100,
    };
    possibleCashOptions.push({ label: `${currenySymbol}${amt.toFixed(2)}`, key: `${amt.toFixed(2)}` });
    const roundeUpNumber = possibleRoundUps[possibleCashOptions.length];
    const newAmt = Math.ceil(amt / roundeUpNumber) * roundeUpNumber;
    if (possibleCashOptions?.length < 7) {
      return getPossibleCashOptions(newAmt);
    }
    return '';
  };
  (() => getPossibleCashOptions())();
  const getCashReturnList = (amt) => {
    let a = amt
    let amount = +(a * 100).toFixed(0);

    const {
      higherUnit, conversionUnit, lowerUnit,
    } = countryDenominations[countryCode];
    const cashList = {};
    const cummulativeUnitsAvailable = countryDenominations[countryCode]?.cummulativeUnit;
    cummulativeUnitsAvailable.forEach((unit) => {
      const length = Math.floor(amount / unit);
      const shouldUpdateAmt = (amount >= unit) && length >= 1;
      if (shouldUpdateAmt) {
        const totalValue = +(length * (unit / conversionUnit));
        cashList[unit] = {
          isHigherUnit: (unit >= conversionUnit),
          conversionUnit,
          unitValue: +(unit / conversionUnit),
          unitSymbol: (unit >= conversionUnit) ? higherUnit.symbol : lowerUnit.symbol,
          cummulativeUnit: unit,
          type: (unit >= conversionUnit) ? 'Bill' : 'Coin',
          totalValue,
          value: (unit >= conversionUnit) ? +(unit / conversionUnit) : unit,
          computedValueInHigherUnit: `${higherUnit.symbol}${(length * (unit / conversionUnit)).toFixed(2)}`,
          length,
        };
        amount -= +(length * unit);
      } else {
        cashList[unit] = {
          isHigherUnit: (unit >= conversionUnit),
          conversionUnit,
          value: (unit >= conversionUnit) ? +(unit / conversionUnit) : unit,
          unitValue: +(unit / conversionUnit),
          unitSymbol: (unit >= conversionUnit) ? higherUnit.symbol : lowerUnit.symbol,
          length: 0,
          totalValue: 0.00,
          cummulativeUnit: unit,
          type: (unit >= conversionUnit) ? 'Bill' : 'Coin',
          computedValueInHigherUnit: `${higherUnit.symbol}0.00`
        };
      }
    });
    return cashList;
  };

  const handleReceipt = (key) => {
    switch (key) {
      case 'phone':
      case 'email': handleReceiptPopUpOpen(key); break;
      case 'paper': handleCheck('print'); break;
      case 'none': handleCheck('receipt'); break;
      default:
        break;
    }
  };

  const handleCashOutSubmit = ({ amount, list }) => {
    setIsCounterCash(false);
    setChangeAmount(amount);
    const amt = +(totalAmount + amount);
    setAmount(amt);
    cashCalculatorRef.current.setKeyboardValue(String(amt));
    setGroupedList(list);
  };

  const intervalId = useRef(null);
  const successDrawerOpen = () => {
    intervalId.current = setInterval(() => {
      EventEmitter.drawerStatus(eventObj, (res) => {
        if ([9, 1].includes(res.status)) {
          handleCheck('drawerOpen');
          setDrawerOpen(false);
          clearInterval(intervalId.current);
        }
      });
    }, 1000);
  };

  const timeoutId = useRef(null);
  let retryCount = 0;
  const handleDrawerStatusCheck = () => {
    retryCount += 1;
    EventEmitter.drawerStatus(eventObj, (res) => {
      timeoutId.current = setTimeout(() => {
        clearTimeout(timeoutId.current);
        if ([1].includes(res.status) && retryCount <= 3) {
          return handleDrawerStatusCheck();
        }
        if (res.status === 0) {
          setDrawerOpen(true);
          setLoader(false);
          setDrawerVisiblity(true);
          setDrawerVisiblityProps(true)
          return successDrawerOpen();
        }
        setLoader(false);
        return setDrawerAlert({ isOpen: true, message: `${CUSTOM_MESSAGES().DRAWER_CASHOUT_FAIL}` });
      }, 1000);
    });
  };

  useEffect(() => {
    if (userInfo?.supportsCashDrawer && paymentType === 17 && totalAmount > 0) {
      setLoader(true);
      if (window.ReactNativeWebView) {
        EventEmitter.drawerOpen(eventObj);
        handleDrawerStatusCheck();
      }
    }
    if ([17, 18].includes(paymentType)) {
      const auth = JSON.parse(window.sessionStorage.getItem('auth'))
      if (auth.serverAppFeatures.lockPaymentScreen) {
        handleHideCancelIcon(true);
      }
    }
  }, [paymentType]);

  const filteredList = (list) => {
    const filterObj = {};
    Object.values(list).forEach((v) => {
      if (v.totalValue > 0) {
        filterObj[v.cummulativeUnit] = v;
      }
    });
    return Object.values(filterObj).sort((a, b) => b.unitValue - a.unitValue);
  };

  const handleChangeValue = (e) => {
    setPreDefinedValue(true)
    const val = (e / 100).toFixed(2);
    setAmount(val);
    let changeAmt = +(val - totalAmount).toFixed(2);
    setChangeAmount(changeAmt > 0 ? changeAmt : 0.00);
    const result = getCashReturnList(changeAmt);
    setGroupedList(result);
  }

  const getMainContainerClass = () => {
    if (isPaymentTerminal && paymentType == 17) {
      return "row mx-0 h-100 w-100 align-items-center od-text-primary text-primary";
    }
    if (isCounter) {
      return "row mx-0 h-100 w-100 align-items-center od-text-primary text-primary";
    }
    return "mx-0 h-100 w-100 align-items-center od-text-primary text-primary";
  };

  const getContentWrapperHeightClass = () => {
    if (isPaymentTerminal) {
      if ([16].includes(paymentType)) {
        return 'h-30 p-0 fw-600 fs-18 d-flex align-items-stretch flex-wrap rounded border border-color-primary';
      }
      return 'h-100 p-2 fw-600 fs-18 d-flex align-items-stretch flex-wrap rounded border border-color-primary';
    }
    if (isCounter) {
      return 'h-100 p-2 fw-600 fs-18 d-flex align-items-stretch flex-wrap rounded border border-color-primary';
    }
    if ([16].includes(paymentType)) {
      return 'h-35';
    }
    return 'h-100';
  };

  const getContentWrapperMarginClass = () => {
    if (isCounter) {
      return '';
    }
    if (isPaymentTerminal) {
      if ([17].includes(paymentType)) {
        return '';
      }
      return 'mt-4';
    }
    if ([17].includes(paymentType)) {
      return '';
    }
    return 'mt-5';
  };

  const getContentWrapperWidthClass = () => {
    if ([16].includes(paymentType) && totalAmount > 0 && isCounter) {
      return 'w-35';
    }
    return 'w-100';
  };

  const getFilteredListHeightClass = () => {
    if (![16].includes(paymentType)) {
      return '';
    }
    if (isPaymentTerminal && [16].includes(paymentType)) {
      return 'h-40';
    }
    return 'h-50';
  };

  return (
    <div className={getMainContainerClass()}>
      {loader && <Loader />}
      {[16].includes(paymentType) && totalAmount > 0 && (
        <div className={cn('row mx-0', [16].includes(paymentType) ? isCounter ? 'h-100 w-65' : 'w-100' : 'd-none')}>
          <div className="text-center w-100 py-2" style={{ fontSize: isServerApp ? "1.5rem" : "1rem" }}>Enter amount equal or greater than {currenySymbol}{countryCode === '44' && (urlSearchParams('type') == 'payType' || isCounter) ? (totalAmount).toFixed(2) : totalAmount.toFixed(2)}</div>
          <div className="w-70">
            <CashCalculator
              ref={cashCalculatorRef}
              name="cashCalculator"
              onChange={handleChangeValue}
              onClickIcon={() => setIsCounterCash(true)}
              value={String(Amount)}
              preDefinedValue={preDefinedValue}
            />
          </div>
          <div className="w-30 row mx-0 align-content-start fw-600 fs-18">
            {possibleCashOptions?.length > 0 && uniqBy(possibleCashOptions, 'key')?.map(({ label, key }) => {
              return (
                <div
                  role="presentation"
                  onClick={() => {
                    setPreDefinedValue(false)
                    setAmount(key);
                    let changeAmt = +(key - totalAmount).toFixed(2);
                    setChangeAmount(changeAmt > 0 ? changeAmt : 0.00);
                    const result = getCashReturnList(changeAmt);
                    setGroupedList(result);          
                  }}

                  className="w-100 text-center h-15 px-2 pb-2"
                >
                  <div className="rounded d-flex justify-content-center align-items-center bg-success h-100 btn-primary btn-ripple roundedSm">
                    {label}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div className={cn(getContentWrapperHeightClass(), getContentWrapperMarginClass(), ' p-2 fw-600 fs-18 d-flex align-items-stretch flex-wrap rounded border border-color-primary', getContentWrapperWidthClass())}>
        <div className={cn([16].includes(paymentType) ? 'd-none' : 'h-10 w-100 text-center')}>{LABEL().COLLECTED}: {`${currenySymbol}${(+Amount).toFixed(2)}`}</div>
        <div className={cn(getFilteredListHeightClass(), 'w-100 d-flex flex-wrap overflowY')}>
          {filteredList(groupedList)?.map(({
            length, value,
            unitSymbol, isHigherUnit,
            computedValueInHigherUnit,
          }) => {
            const displayAmt = value;
            const concatAmtWithSymbol = isHigherUnit ? `${unitSymbol}${displayAmt}` : `${displayAmt}${unitSymbol}`;
            return (
              <div className="w-100 row mx-0">
                <div className="w-50 text-left">{`${length} x ${concatAmtWithSymbol}`}</div>
                <div className="w-50 text-right">{`${computedValueInHigherUnit}`}</div>
              </div>
            );
          })}
        </div>
        <div className={cn("w-100 fs-30 text-center mb-1")}>
          <div className={cn('w-100 fs-26')} style={{ lineHeight: '1' }}>{LABEL().CHANGE}</div>
          {`${currenySymbol} ${Number(changeAmount).toFixed(2)}`}
        </div>
        <div className={cn('w-100 p-0 row mx-0', isCounter ? 'mt-auto' : '', [16].includes(paymentType) ? cn('align-items-center h-25', styles.alignContentSpaceEvenly) : 'align-content-end', !isPaymentTerminal ? 'h-15' : '')}>
          {[16].includes(paymentType) && (
            <>
              {isCounter && <button type="button" onClick={() => handleChangePaymentType()} className={cn('w-100 btn rounded od-btn-primary btn-primary btn-ripple d-flex align-items-center justify-content-center')}>{LABEL().CHANGE_PAYMENT_TYPE}</button>}
              <button type="button" disabled={Number(totalAmount).toFixed(2) === Number(Amount).toFixed(2) ? false : (Number(totalAmount) >= Number(Amount))} onClick={() => handleCheck('counterCashPay')} className={cn('w-100 btn rounded od-btn-primary btn-primary btn-ripple d-flex align-items-center justify-content-center')} style={{ fontSize: isServerApp ? '2rem' : '20px' }}>{LABEL().FINALIZE}</button>
            </>
          )}
          {[17].includes(paymentType) && drawerVisibilty && (
            <div className={cn('w-100 rounded d-flex align-items-center btn35 justify-content-center', !drawerOpen ? 'bg-green color-white' : 'bg-red color-white')}>
              {LABEL().DRAWER_OPEN}
            </div>
          )}
          {[17].includes(paymentType) && !drawerVisibilty && (
            <div role="presentation" onClick={() => { handleCheck('drawerOpen'); }} className={cn('col-12 px-0')} >
              <button className={cn('od-btn-primary text-center btn-primary btn-ripple btn rounded col-md-12')} style={{ fontSize: isPaymentTerminal ? '16px' : '20px', textTransform: 'uppercase' }}>{LABEL().GO_TO_RECEIPT}</button>
            </div>
          )}
          {[18].includes(paymentType) && receiptButtons.map(({ key, label, show }) => {
            return show && (
              <div role="presentation" onClick={() => handleReceipt(key)} className={cn('w-50 p-1')}>
                <div className="rounded od-btn-primary btn-primary btn-ripple d-flex align-items-center btn35 justify-content-center">{label}</div>
              </div>
            );
          })}
        </div>
      </div>
      {isCounterCash && (
        <Modal
          isOpen={isCounterCash}
        >
          <div className={cn('w-100 fs-18 row mx-0', styles.modalHeight)}>
            <div className={cn('col-12 px-1 h-5 fs-24 text-right')} role="presentation" onClick={() => setIsCounterCash(false)}>
              <i className="fa fa-times od-text-primary text-primary" aria-hidden="true" />
            </div>
            <div className="p-2 d-flex flex-wrap justify-content-around align-items-center h-95 text-center">
              <CounterCash list={groupedList} amount={changeAmount} onSubmit={handleCashOutSubmit} />
            </div>
          </div>
        </Modal>
      )}
      {drawerAlert && (
        <Modal
          isOpen={drawerAlert}
          isModalCenter
        >
          <div className={cn('w-100 fs-18 row mx-0 p-2 text-center')}>
            <div className="text-center py-2">{CUSTOM_MESSAGES().DRAWER_OPEN_FAIL}</div>
            <div role="presentation" onClick={() => { setDrawerAlert(false); handleCheck('drawerOpen'); }} className="col-6 offset-3 p-2">
              <div className="od-btn-primary btn-primary btn-ripple btn35 roundedSm">{LABEL().GO_TO_RECEIPT}</div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};
CashReturn.propTypes = {
  totalAmount: PropTypes.number,
  paymentType: PropTypes.number,
  deviceInfo: PropTypes.object,
  tableData: PropTypes.object,
  userInfo: PropTypes.object,
  handleReceiptPopUpOpen: PropTypes.func,
  handleCheck: PropTypes.func,
  setDrawerVisiblityProps: PropTypes.func,
  handleHideCancelIcon: PropTypes.func,
  handleChangePaymentType: PropTypes.func,
  isCounter: PropTypes.bool,
  receiptTypes: PropTypes.object,
};
CashReturn.defaultProps = {
  totalAmount: 0.0,
  paymentType: 0,
  deviceInfo: {},
  tableData: {},
  userInfo: {},
  handleReceiptPopUpOpen: () => {},
  handleCheck: () => {},
  setDrawerVisiblityProps: () => {},
  handleHideCancelIcon: () => {},
  handleChangePaymentType: () => {},
  isCounter: false,
  receiptTypes: {},
};


export default CashReturn;
